/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_TitleInputs */

const en_admin_subscriptions_title = /** @type {(inputs: Admin_Subscriptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Admin_Subscriptions_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_title = /** @type {((inputs?: Admin_Subscriptions_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_title(inputs)
});
export { admin_subscriptions_title as "admin.subscriptions.title" }